import type { FilterInstance } from '../../../core/model';
import type { Registry } from '../../../core/registry';

export type FilterType = 'video' | 'audio';

/** Unknown kinds (missing plugin) are listed with the video filters so they stay removable. */
export function filterTypeOf(registry: Pick<Registry, 'getFilter'>, kind: string): FilterType {
  return registry.getFilter(kind)?.type === 'audio' ? 'audio' : 'video';
}

export function splitFilters(
  registry: Pick<Registry, 'getFilter'>,
  filters: readonly FilterInstance[],
): Record<FilterType, FilterInstance[]> {
  const out: Record<FilterType, FilterInstance[]> = { video: [], audio: [] };
  for (const filter of filters) out[filterTypeOf(registry, filter.kind)].push(filter);
  return out;
}

/**
 * Video and audio filters share one stored list. Moving a filter one step
 * within its own type means jumping to the stored index of the neighbouring
 * filter of that type. Returns null at the ends.
 */
export function moveWithinType(
  registry: Pick<Registry, 'getFilter'>,
  filters: readonly FilterInstance[],
  filterId: string,
  step: 1 | -1,
): number | null {
  const index = filters.findIndex((f) => f.id === filterId);
  if (index < 0) return null;
  const type = filterTypeOf(registry, filters[index]!.kind);
  for (let i = index + step; i >= 0 && i < filters.length; i += step) {
    if (filterTypeOf(registry, filters[i]!.kind) === type) return i;
  }
  return null;
}
